import { Box, Card, Tab, Tabs, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MissionControlTenant } from "src/store/api/generatedApi";
import { TenantRow } from "./TenantRow";
import { MissionControlTotalSavingsCard } from "./MissionControlTotalSavingsCard";

export type MissionControlTab =
  "savings" | "inventory" | "schedule" | "steelMix" | "shredUsage";

export const TenantListPanel = ({
  tenants,
  savingsTarget,
  selectedTenant,
  onSelectTenant,
  onHoverTenant,
  activeTab,
  onTabChange,
}: {
  tenants: MissionControlTenant[];
  savingsTarget: number;
  selectedTenant: MissionControlTenant | null;
  onSelectTenant: (tenant: MissionControlTenant | null) => void;
  onHoverTenant: (tenant: MissionControlTenant | null) => void;
  activeTab: MissionControlTab;
  onTabChange: (tab: MissionControlTab) => void;
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Card
      sx={{
        width: 380,
        flexShrink: 0,
        background: "rgba(255,255,255,0.35)",
        backdropFilter: "saturate(180%) blur(18px)",
        WebkitBackdropFilter: "saturate(180%) blur(18px)",
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
        borderRadius: 3,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        maxHeight: "100%",
      }}
    >
      <MissionControlTotalSavingsCard
        tenants={tenants}
        savingsTarget={savingsTarget}
      />
      <Tabs
        value={activeTab}
        onChange={(_, value: MissionControlTab) => {
          onTabChange(value);
        }}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: "divider", minHeight: 40 }}
      >
        <Tab
          label={t("savings")}
          value="savings"
          sx={{ minHeight: 40, py: 1 }}
        />
        <Tab
          label={t("inventory")}
          value="inventory"
          sx={{ minHeight: 40, py: 1 }}
        />
        <Tab label={t("SIOP")} value="schedule" sx={{ minHeight: 40, py: 1 }} />
        <Tab
          label={t("steelMix")}
          value="steelMix"
          sx={{ minHeight: 40, py: 1 }}
        />
        <Tab
          label={t("shredUsage")}
          value="shredUsage"
          sx={{ minHeight: 40, py: 1 }}
        />
      </Tabs>
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {tenants.map((tenant) => (
          <TenantRow
            key={tenant.tenant_name}
            tenant={tenant}
            activeTab={activeTab}
            isSelected={selectedTenant?.tenant_name === tenant.tenant_name}
            onSelect={() => {
              onSelectTenant(tenant);
            }}
            onHover={(hovered) => {
              onHoverTenant(hovered ? tenant : null);
            }}
          />
        ))}
      </Box>
    </Card>
  );
};
